import { defineComponent, ref } from "vue";
import { getLimit, saveLimit } from "@/api/my";
import { showNotify } from "vant";
import Loading from "@/components/loading/index.vue";
export default defineComponent({
  name: "Recharge",
  components: {
    Loading
  },
  setup() {
    // 返回按钮
    // const onClickLeft = () => history.back();
    // 查询
    const list = ref();
    const overlayShow = ref(true);
    getLimit().then(({
      code,
      data
    }) => {
      console.log(data);
      if (code === 200) {
        list.value = data;
      }
    }).finally(() => {
      overlayShow.value = false;
    });
    const value = ref();
    const loading = ref(false);
    const submit = () => {
      loading.value = true;
      console.log("submit", list.value);
      saveLimit(list.value).then(({
        code,
        msg
      }) => {
        if (code === 200) {
          showNotify({
            type: "success",
            message: msg
          });
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    return {
      // onClickLeft,
      value,
      loading,
      overlayShow,
      list,
      submit
    };
  }
});